import React, { Component } from "react";

class PendingPatientListItem extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <React.Fragment>
        <li>
          <div class="row">
            <div class="col-md-5 col-sm-12">
              <div class="sypmtom-info">
                <div class="symptom-img">
                  <img src="assets/img/icons/ic-patient-img.png" alt="" />
                </div>
                <div class="symptom-title">
                  <h2>
                    Chronic Headache <span>James</span>
                  </h2>
                </div>
              </div>
            </div>
            <div class="col-md-3 col-sm-12">
              <div class="symptom-date">
                <p>19 -May-2018</p>
              </div>
            </div>
            <div class="col-md-4 col-sm-12">
              <div class="symptom-state">
                <p>
                  <img src="assets/img/icons/ic-waiting.png" alt="" /> Waiting
                  for Approval
                </p>
              </div>
            </div>
          </div>
        </li>
      </React.Fragment>
    );
  }
}

export default PendingPatientListItem;
